import React from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


interface IframeworkMobilePaytable {
    data: {}
}

export const frameworkMobilePaytable: IframeworkMobilePaytable = {
    data: {
        "COMPONENTS": [
            {
                "id": "gameScrollComponentMob",
                "name": "gameScrollComponentMob",
                "type": "Container",
                "x": 0,
                "y": 0,
                "visible": true,
                "layout": true,
                "uimode": "mobile",
                "filterTypes": [],
                child: [

                ]
            },

            {
                "id": "paytableContent",
                "name": "paytableContent",
                "type": "Container",
                "x": -261,
                "y": -73,
                "visible": true,
                "layout": true,
                "uimode": "mobile",
                "filterTypes": [],
                child: [
                    {
                        id: "thirdSlide_ContainerMobile",
                        "name": "slide_Container3Mobile",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "x": 0,
                        "y": 0,
                        "width": 1920,
                        "height": 1080,
                        "filterTypes": [],
                        child: [
                            {
                                "id": "firstSlideText1",
                                "name": "Text_paytable",
                                "type": "Text",
                                "x": 963,
                                "y": 120,
                                "visible": true,
                                "text": "paytableHeading1",
                                "width": 280,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 60,
                                    fontWeight: 'normal',
                                    fill: ['#ffea00'],
                                    wordWrap: true,

                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            /*    {
                                   "id": "thirdSlideText1",
                                   "name": "thirdSlideText1",
                                   "type": "Text",
                                   "x": 963,
                                   "y": 120,
                                   "visible": true,
                                   "text": "paytableHeading1",
                                   "width": 280,
                                   "anchor": [0.5, 0.5],
                                   "textStyle": {
                                       fontFamily: 'NotoSansCJKsc-Regular',
                                       fontSize: 60,
                                       fontWeight: 'normal',
                                       fill: ['#ffea00'],
                                       wordWrap: true,
   
                                   },
                                   "parentLayer": "specialAnimationLayer",
                               }, */
                            {
                                "name": "thirdSlideImage1",
                                "image": "thirdSlideImage1",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 1042,
                                "height": 568,
                                "x": 449,
                                "y": 239,
                            },
                            {
                                id: "thirdSlide_FirstLineTextContainer",
                                "name": "thirdSlide_FirstLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 0,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "thirdSlideText2",
                                        "name": "thirdSlideText2",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "15+",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText3",
                                        "name": "thirdSlideText3",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText4",
                                        "name": "thirdSlideText4",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText5",
                                        "name": "thirdSlideText5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText6",
                                        "name": "thirdSlideText6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "11",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText7",
                                        "name": "thirdSlideText7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "10",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText8",
                                        "name": "thirdSlideText8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "9",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText9",
                                        "name": "thirdSlideText9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "8",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText10",
                                        "name": "thirdSlideText10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "7",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText11",
                                        "name": "thirdSlideText11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "6",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText12",
                                        "name": "thirdSlideText12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "5",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },

                            {
                                id: "thirdSlide_SecondLineTextContainer",
                                "name": "thirdSlide_SecondLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 108,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "thirdSlideText13",
                                        "name": "symid_4_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText14",
                                        "name": "symid_4_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText15",
                                        "name": "symid_4_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText16",
                                        "name": "symid_4_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText17",
                                        "name": "symid_4_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText18",
                                        "name": "symid_4_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText19",
                                        "name": "symid_4_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText20",
                                        "name": "symid_4_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText21",
                                        "name": "symid_4_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText22",
                                        "name": "symid_4_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText23",
                                        "name": "symid_4_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },


                            {
                                id: "thirdSlide_ThirdLineTextContainer",
                                "name": "thirdSlide_ThirdLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 316,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "thirdSlideText24",
                                        "name": "symid_3_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText25",
                                        "name": "symid_3_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText26",
                                        "name": "symid_3_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText27",
                                        "name": "symid_3_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText28",
                                        "name": "symid_3_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText29",
                                        "name": "symid_3_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText30",
                                        "name": "symid_3_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText31",
                                        "name": "symid_3_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText32",
                                        "name": "symid_3_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText33",
                                        "name": "symid_3_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText34",
                                        "name": "symid_3_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },

                            {
                                id: "thirdSlide_forthLineTextContainer",
                                "name": "thirdSlide_forthLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 526,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "thirdSlideText35",
                                        "name": "symid_2_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText36",
                                        "name": "symid_2_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText37",
                                        "name": "symid_2_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText38",
                                        "name": "symid_2_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText39",
                                        "name": "symid_2_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText40",
                                        "name": "symid_2_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText41",
                                        "name": "symid_2_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText42",
                                        "name": "symid_2_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText43",
                                        "name": "symid_2_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText44",
                                        "name": "symid_2_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText45",
                                        "name": "symid_2_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },
                            {
                                id: "thirdSlide_fifthLineTextContainer",
                                "name": "thirdSlide_fifthLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 732,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "thirdSlideText46",
                                        "name": "symid_1_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText47",
                                        "name": "symid_1_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText48",
                                        "name": "symid_1_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText49",
                                        "name": "symid_1_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText50",
                                        "name": "symid_1_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText51",
                                        "name": "symid_1_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText52",
                                        "name": "symid_1_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText53",
                                        "name": "symid_1_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText54",
                                        "name": "symid_1_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText55",
                                        "name": "symid_1_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText56",
                                        "name": "symid_1_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },
                            {
                                id: "thirdSlide_SixthLineTextContainer",
                                "name": "thirdSlide_SixthLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 940,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "thirdSlideText57",
                                        "name": "symid_0_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText58",
                                        "name": "symid_0_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText59",
                                        "name": "symid_0_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "thirdSlideText60",
                                        "name": "symid_0_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText61",
                                        "name": "symid_0_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "thirdSlideText62",
                                        "name": "symid_0_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText63",
                                        "name": "symid_0_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "thirdSlideText64",
                                        "name": "symid_0_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText65",
                                        "name": "symid_0_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText66",
                                        "name": "symid_0_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "thirdSlideText67",
                                        "name": "symid_0_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },
                        ]

                    },


                    {
                        id: "secondSlide_ContainerMobile",
                        "name": "slide_Container2Mobile",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "x": 0,
                        "y": 727,
                        "width": 1920,
                        "height": 1080,
                        "filterTypes": [],
                        child: [
                            /*   {
                                  "id": "secondSlideText1",
                                  "name": "Text_paytable",
                                  "type": "Text",
                                  "x": 963,
                                  "y": 120,
                                  "visible": true,
                                  "text": "paytableHeading1",
                                  "width": 280,
                                  "anchor": [0.5, 0.5],
                                  "textStyle": {
                                      fontFamily: 'NotoSansCJKsc-Regular',
                                      fontSize: 60,
                                      fontWeight: 'normal',
                                      fill: ['#ffea00'],
                                      wordWrap: true,
  
                                  },
                                  "parentLayer": "specialAnimationLayer",
                              }, */
                            {
                                "name": "secondSlideImage1",
                                "image": "secondSlideImage1",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 1042,
                                "height": 568,
                                "x": 449,
                                "y": 239,
                            },
                            {
                                id: "secondSlide_FirstLineTextContainer",
                                "name": "secondSlide_FirstLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 0,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "secondSlideText2",
                                        "name": "secondSlideText2",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "15+",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText3",
                                        "name": "secondSlideText3",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText4",
                                        "name": "secondSlideText4",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText5",
                                        "name": "secondSlideText5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText6",
                                        "name": "secondSlideText6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "11",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText7",
                                        "name": "secondSlideText7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "10",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText8",
                                        "name": "secondSlideText8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "9",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText9",
                                        "name": "secondSlideText9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "8",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText10",
                                        "name": "secondSlideText10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "7",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText11",
                                        "name": "secondSlideText11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "6",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText12",
                                        "name": "secondSlideText12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "5",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#f8c119'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },

                            {
                                id: "secondSlide_SecondLineTextContainer",
                                "name": "secondSlide_SecondLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 105,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "secondSlideText13",
                                        "name": "symid_9_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText14",
                                        "name": "symid_9_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText15",
                                        "name": "symid_9_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText16",
                                        "name": "symid_9_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText17",
                                        "name": "symid_9_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText18",
                                        "name": "symid_9_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText19",
                                        "name": "symid_9_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText20",
                                        "name": "symid_9_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText21",
                                        "name": "symid_9_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText22",
                                        "name": "symid_9_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText23",
                                        "name": "symid_9_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },


                            {
                                id: "secondSlide_ThirdLineTextContainer",
                                "name": "secondSlide_ThirdLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 313,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "secondSlideText24",
                                        "name": "symid_8_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText25",
                                        "name": "symid_8_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText26",
                                        "name": "symid_8_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText27",
                                        "name": "symid_8_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText28",
                                        "name": "symid_8_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText29",
                                        "name": "symid_8_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText30",
                                        "name": "symid_8_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText31",
                                        "name": "symid_8_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText32",
                                        "name": "symid_8_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText33",
                                        "name": "symid_8_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText34",
                                        "name": "symid_8_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },

                            {
                                id: "secondSlide_forthLineTextContainer",
                                "name": "secondSlide_forthLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 523,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "secondSlideText35",
                                        "name": "symid_7_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText36",
                                        "name": "symid_7_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText37",
                                        "name": "symid_7_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText38",
                                        "name": "symid_7_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText39",
                                        "name": "symid_7_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText40",
                                        "name": "symid_7_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText41",
                                        "name": "symid_7_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText42",
                                        "name": "symid_7_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText43",
                                        "name": "symid_7_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText44",
                                        "name": "symid_7_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText45",
                                        "name": "symid_7_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },
                            {
                                id: "secondSlide_fifthLineTextContainer",
                                "name": "secondSlide_fifthLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 729,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "secondSlideText46",
                                        "name": "symid_6_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText47",
                                        "name": "symid_6_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText48",
                                        "name": "symid_6_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText49",
                                        "name": "symid_6_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText50",
                                        "name": "symid_6_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText51",
                                        "name": "symid_6_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText52",
                                        "name": "symid_6_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText53",
                                        "name": "symid_6_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText54",
                                        "name": "symid_6_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText55",
                                        "name": "symid_6_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText56",
                                        "name": "symid_6_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },
                            {
                                id: "secondSlide_SixthLineTextContainer",
                                "name": "secondSlide_SixthLineTextContainer",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 937,
                                "y": 0,
                                // "width": 1920,
                                // "height": 1080,
                                "filterTypes": [],
                                child: [

                                    {
                                        "id": "secondSlideText57",
                                        "name": "symid_5_mul_15",
                                        "type": "Text",
                                        "x": 475,
                                        "y": 385,
                                        "width": 510,
                                        "visible": true,
                                        "text": "secondSlideText12",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText58",
                                        "name": "symid_5_mul_14",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 424,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText13",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText59",
                                        "name": "symid_5_mul_13",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 465,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText14",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                    {
                                        "id": "secondSlideText60",
                                        "name": "symid_5_mul_12",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 507,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText15",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText61",
                                        "name": "symid_5_mul_11",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 546,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText16",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },

                                    {
                                        "id": "secondSlideText62",
                                        "name": "symid_5_mul_10",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 587,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText17",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText63",
                                        "name": "symid_5_mul_9",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 627,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText18",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },


                                    {
                                        "id": "secondSlideText64",
                                        "name": "symid_5_mul_8",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 669,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText19",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText65",
                                        "name": "symid_5_mul_7",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 709,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText20",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText66",
                                        "name": "symid_5_mul_6",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 751,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText21",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },



                                    {
                                        "id": "secondSlideText67",
                                        "name": "symid_5_mul_5",
                                        "type": "Text",
                                        "x": 471,
                                        "y": 791,
                                        "width": 540,
                                        "visible": true,
                                        "text": "secondSlideText22",
                                        "anchor": [0.5, 0.5],
                                        "scaleToFit": true,
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular_2',
                                            fontSize: 28,
                                            fontWeight: 'normal',
                                            fill: ['#ffffff'],
                                            align: "center",

                                        },
                                    },
                                ]
                            },


                            {
                                "id": "firstSlideText36",
                                "name": "firstSlideText36",
                                "type": "Text",
                                "x": 970,
                                "y": 870,
                                "width": 1500,
                                "visible": true,
                                "text": "paytablePage1_1",
                                "anchor": [0.5, 0.5],
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    align: 'center',
                                    fill: ['#d8d6d4'],

                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            {
                                "id": "firstSlideText36",
                                "name": "firstSlideText36",
                                "type": "Text",
                                "x": 970,
                                "y": 920,
                                "width": 1500,
                                "visible": true,
                                "text": "paytablePage1_2",
                                "anchor": [0.5, 0.5],
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    align: 'center',
                                    fill: ['#d8d6d4'],

                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                        ]



                    },

                    {
                        id: "firstSlide_ContainerMobile",
                        "name": "slide_Container1Mobile",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "x": 0,
                        "y": 1488,
                        "width": 1920,
                        "height": 1080,
                        "filterTypes": [],
                        child: [

                            {
                                "name": "firstSlideImage1",
                                "image": "firstSlideImage2",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 376,
                                "height": 381,
                                "x": 401,
                                "y": 311,
                            },

                            {
                                "name": "firstSlideImage2",
                                "image": "firstSlideImage1",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 376,
                                "height": 381,
                                "x": 1132,
                                "y": 311,
                            },





                            {
                                "id": "firstSlideText5",
                                "name": "firstSlideText5",
                                "type": "Text",
                                "x": 586,
                                "y": 781,
                                "width": 1080,
                                "visible": true,
                                "text": "paytablePage3_1",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    wordWrap: true,
                                    wordWrapWidth: 700,


                                }
                            },

                            {
                                "id": "firstSlideText6",
                                "name": "firstSlideText6",
                                "type": "Text",
                                "x": 1329,
                                "y": 784,
                                "width": 1080,
                                "visible": true,
                                "text": "paytablePage3_2",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    wordWrap: true,
                                    wordWrapWidth: 700,

                                }
                            },

                        ]

                    },




                    {
                        id: "forthSlide_ContainerMobile",
                        "name": "slide_Container4Mobile",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "x": 0,
                        "y": 2330,
                        "width": 1200,
                        "height": 1080,
                        "filterTypes": [],
                        child: [

                            {
                                "name": "forthSlideImage1",
                                "image": "forthSlideImage2",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 560,
                                "height": 244,
                                "x": 700,
                                "y": 219,
                            },

                            {
                                "id": "forthSlideText1",
                                "name": "forthSlideText1",
                                "type": "Text",
                                "x": 963,
                                "y": 120,
                                "visible": true,
                                "text": "paytableHeading4",
                                "width": 610,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 60,
                                    fontWeight: 'normal',
                                    fill: ['#ffea00'],
                                    //  wordWrap: true,
                                    align: "center",
                                },
                                "parentLayer": "specialAnimationLayer",
                            },


                            {
                                "id": "forthSlideText2",
                                "name": "forthSlideText2",
                                "type": "Text",
                                "x": 400,
                                "y": 542,
                                "width": 1200,
                                "visible": true,
                                "text": "paytablePage4_2",
                                "scaleToFit": true,
                                "anchor": [0, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    wordWrapWidth: 1200,
                                    wordWrap: true,


                                }
                            },
                            {
                                "id": "forthSlideText3",
                                "name": "forthSlideText3",
                                "type": "Text",
                                "x": 400,
                                "y": 637,
                                "width": 1200,
                                "visible": true,
                                "text": "paytablePage4_3",
                                "scaleToFit": true,
                                "anchor": [0, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    wordWrapWidth: 1200,
                                    wordWrap: true,


                                }
                            },
                            {
                                "id": "forthSlideText4",
                                "name": "forthSlideText4",
                                "type": "Text",
                                "x": 400,
                                "y": 732,
                                "width": 1200,
                                "visible": true,
                                "text": "paytablePage4_4",
                                "scaleToFit": true,
                                "anchor": [0, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    wordWrapWidth: 1200,
                                    wordWrap: true,


                                }
                            },
                            {
                                "id": "forthSlideText5",
                                "name": "forthSlideText5",
                                "type": "Text",
                                "x": 400,
                                "y": 842,
                                "width": 1200,
                                "visible": true,
                                "text": "paytablePage4_5",
                                "scaleToFit": true,
                                "anchor": [0, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    wordWrapWidth: 1200,
                                    wordWrap: true,


                                }
                            },
                            {
                                "id": "forthSlideText6",
                                "name": "forthSlideText6",
                                "type": "Text",
                                "x": 400,
                                "y": 972,
                                "width": 1200,
                                "visible": true,
                                "text": "paytablePage4_6",
                                "scaleToFit": true,
                                 "anchor": [0, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    wordWrapWidth: 1200,
                                    wordWrap: true,


                                }
                            },
                        ]

                    },

                    {
                        id: "fifthSlide_ContainerMobile",
                        "name": "slide_Container5Mobile",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "x": 0,
                        "y": 3245,
                        "width": 1920,
                        "height": 1080,
                        "filterTypes": [],
                        child: [
                            {
                                "id": "fifthSlideText1",
                                "name": "fifthSlideText1",
                                "type": "Text",
                                "x": 963,
                                "y": 180,
                                "width": 510,
                                "visible": true,
                                "text": "paytableHeading5",
                                "anchor": [0.5, 0.5],
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 60,
                                    fontWeight: 'normal',
                                    fill: ['#ffea00'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },





                            {
                                "name": "fifthSlideImage1",
                                "image": "fifthSlideImage1",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 600,
                                "height": 338,
                                "x": 659,
                                "y": 266,
                            },










                            {
                                "id": "fifthSlideText3",
                                "name": "fifthSlideText3",
                                "type": "Text",
                                "x": 950,
                                "y": 720,
                                "width": 1200,
                                "visible": true,
                                "text": "paytablePage5_2",
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: 'center'

                                }
                            },
                            {
                                "id": "fifthSlideText3",
                                "name": "fifthSlideText3",
                                "type": "Text",
                                "x": 950,
                                "y": 783,
                                "width": 1200,
                                "visible": true,
                                "text": "paytablePage5_3",
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: 'center'

                                }
                            },

                        ]
                    },

                    {
                        id: "sixthSlide_ContainerMobile",
                        "name": "slide_Container6Mobile",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "x": 0,
                        "y": 4086,
                        "width": 1920,
                        "height": 1080,
                        "filterTypes": [],
                        child: [
                            {
                                "id": "fifthSlideText1",
                                "name": "Text_paytable",
                                "type": "Text",
                                "x": 963,
                                "y": 120,
                                "width": 650,
                                "visible": true,
                                "text": "paytablePage6_1",
                                "anchor": [0.5, 0.5],
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 60,
                                    fontWeight: 'normal',
                                    fill: ['#ffea00'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },



                            {
                                "id": "sixthSlideText2",
                                "name": "sixthSlideText2",
                                "type": "Text",
                                "x": 967,
                                "y": 270,
                                "width": 340,
                                "visible": true,
                                "text": "paytablePage6_2",

                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 42,
                                    fontWeight: 'normal',
                                    fill: ['#ffea00'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            {
                                "id": "sixthSlideText3",
                                "name": "fifthSlideText3-0",
                                "type": "Text",
                                "x": 938,
                                "y": 377,
                                "width": 1920,
                                "visible": true,
                                "text": "paytablePage6_3",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: "center",
                                }
                            },
                            {
                                "id": "sixthSlideText3",
                                "name": "fifthSlideText3-1",
                                "type": "Text",
                                "x": 966,
                                "y": 447,
                                "width": 1920,
                                "visible": true,
                                "text": "paytablePage6_4",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: "center",
                                }
                            },
                            {
                                "id": "sixthSlideText3",
                                "name": "fifthSlideText3-2",
                                "type": "Text",
                                "x": 938,
                                "y": 507,
                                "width": 1920,
                                "visible": true,
                                "text": "paytablePage6_5",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: "center",
                                }
                            },

                            {
                                "id": "sixthSlideText4",
                                "name": "sixthSlideText4",
                                "type": "Text",
                                "x": 967,
                                "y": 571,
                                "width": 340,
                                "visible": true,
                                "text": "paytablePage6_6",

                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 42,
                                    fontWeight: 'normal',
                                    fill: ['#ffea00'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            {
                                "id": "sixthSlideText5",
                                "name": "fifthSlideText5",
                                "type": "Text",
                                "x": 938,
                                "y": 674,
                                "width": 1920,
                                "visible": true,
                                "text": "paytablePage6_7",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: "center",
                                }
                            },
                            {
                                "id": "sixthSlideText5",
                                "name": "fifthSlideText5",
                                "type": "Text",
                                "x": 968,
                                "y": 742,
                                "width": 1920,
                                "visible": true,
                                "text": "paytablePage6_8",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: "center",
                                }
                            },
                            //{
                            //    "id": "sixthSlideText4",
                            //    "name": "fifthSlideText4",
                            //    "type": "Text",
                            //    "x": 963,
                            //    "y": 400,
                            //    "width": 1920,
                            //    "visible": true,
                            //    "text": "sixthSlideText4",
                            //    "scaleToFit": true,
                            //    //"anchor": [0.5, 0.5],
                            //    "textStyle": {
                            //        fontFamily: 'NotoSansCJKsc-Regular',
                            //        fontSize: 32,
                            //        fontStyle: 'normal',
                            //        fill: ['#d8d6d4'],
                            //        align: "center",
                            //    }
                            //},

                        ]

                    },


                    {
                        id: "seventhSlide_ContainerMobile",
                        "name": "slide_Container7Mobile",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "x": 0,
                        "y": 4880,
                        "width": 1920,
                        "height": 1080,
                        "filterTypes": [],
                        child: [
                            {
                                "id": "seventhSlideText1",
                                "name": "Text_paytable",
                                "type": "Text",
                                "x": 963,
                                "y": 120,
                                "width": 470,
                                "visible": true,
                                "text": "paytableHeading2",
                                "anchor": [0.5, 0.5],
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 60,
                                    fontWeight: 'normal',
                                    fill: ['#ffea00'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },

                            {
                                "name": "seventhSlideImage1",
                                "image": "seventhSlideImage1",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 298,
                                "height": 297,
                                "x": 818,
                                "y": 292,
                            },


                            /* {
                                "id": "seventhSlideText2",
                                "name": "Text_paytable",
                                "type": "Text",
                                "x": 963,
                                "y": 255,
                                "width": 340,
                                "visible": true,
                                "text": "seventhSlideText1",
        
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 42,
                                    fontWeight: 'bold',
                                    fill: ['#ffea00'],
                                    align: "center",
        
                                },
                                "parentLayer": "specialAnimationLayer",
                            }, */
                            {
                                "id": "seventhSlideText3",
                                "name": "seventhSlideText3",
                                "type": "Text",
                                "x": 968,
                                "y": 638,
                                "width": 1920,
                                "visible": true,
                                "text": "paytablePage7_1",
                                "scaleToFit": true,
                                //"anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: "left",
                                }
                            },
                            {
                                "id": "seventhSlideText4",
                                "name": "seventhSlideText4",
                                "type": "Text",
                                "x": 342,
                                "y": 725,
                                "width": 1920,
                                "visible": true,
                                "text": "paytablePage7_2",
                                "scaleToFit": true,
                                "anchor": [0, 0.5],
                                "textStyle": {
                                    fontFamily: 'NotoSansCJKsc-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#d8d6d4'],
                                    align: "left",
                                }
                            },


                        ]

                    },

                ]
            }
            //    {
            //        "name": "winCelebration_Graphic",
            //        "type": "Graphic",
            //        "shape": "rectangle",
            //        "visible": true,
            //        "alpha": 1,
            //        "color": "0x000000",
            //        "x": 0,
            //        "y": 0,
            //        "width": 1920,
            //        "height": 1080,
            //
            //    },












        ]
    }

};
export const mobilePaytableConfigurationContext = React.createContext(
    {}
);